const ReactTag = () => {
  return (
    <div className="tag react">
      <span className="tagText">React.js</span>
    </div>
  );
};

export default ReactTag;
